module.exports = __webpack_public_path__ + "img/logo.72726c5a.png";